"use client";

import { motion } from "framer-motion";
import Link from "next/link"; // Use Next.js Link component
import Image from "next/image";

export default function FeaturesRow_3DCard({ data }: any) {
  const features = data?.features || [];

  return (
    <section className="py-10 sm:py-14 bg-white relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        {/* Header */}
        <div className="text-center mb-10 sm:mb-12">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-light tracking-tight text-gray-900">
            {data?.title}
          </h2>
          <p className="text-gray-600 max-w-xl mx-auto text-sm md:text-base leading-relaxed px-3 mt-3">
            {data?.description}
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8 md:gap-10">
          {features.map((f: any, i: any) => {
            const linkUrl = f.link?.url || "#"; // Default to "#" if no link

            return (
              <motion.div
                key={i}
                whileHover={{ scale: 1.02, rotateX: 3, rotateY: -3 }}
                transition={{ type: "spring", stiffness: 180, damping: 18 }}
                className="group cursor-pointer bg-white border border-gray-200 
                shadow-[0_0_20px_rgba(0,0,0,0.05)]
                overflow-hidden rounded-none transition-all duration-300
                h-full flex flex-col"
              >
                {/* Link wrapping entire card or specific section */}
                <Link href={linkUrl} passHref>
                  <div className="relative w-full aspect-[2/3] overflow-hidden">
                    <Image
                      src={f.media?.data?.attributes?.url}
                      alt={f.title}
                      fill
                      className="object-cover transition-all duration-500 
                    group-hover:scale-110 group-hover:brightness-90"
                    />
                  </div>

                  {/* Content */}
                  <div className="p-4 sm:p-6 flex-1 flex flex-col">
                    <h3 className="text-lg sm:text-xl font-semibold tracking-wide text-gray-900 mb-2 sm:mb-3 group-hover:text-black">
                      {f.title}
                    </h3>
                    <p className="text-gray-600 text-sm sm:text-base leading-relaxed line-clamp-3 flex-1">
                      {f.description}
                    </p>
                  </div>
                </Link>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
